import script from "./artmisadsInputPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./artmisadsInputPassword.vue?vue&type=script&setup=true&lang=js"

import "./artmisadsInputPassword.vue?vue&type=style&index=0&id=2cb96135&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb96135"]])

export default __exports__